import {FC, useMemo} from "react";
import {NewsItemPageBodyProps} from "../../types";
import * as BUCKETS from "../../../../../enums/buckets"
import "./style.less"
import {getImageLink} from "../../../../../helpers/mainHelpers";
import {Empty, Image} from "antd";
import TextReader from "../../../../../components/text-reader/TextReader";
import Gallery from "../../../../../components/galerry/Gallery";
import dayjs from "dayjs";
import {CalendarOutlined, PictureOutlined} from "@ant-design/icons";


const NewsItemPageBody: FC<NewsItemPageBodyProps> = (props) => {
  const {currentNewsItem} = props

  const galleryImages = useMemo(() => {
    if (currentNewsItem?.images?.length) {
      return currentNewsItem.images
        .filter((image) => image !== currentNewsItem.mainImage)
        .map((image) => {
          return getImageLink({bucketId: BUCKETS.MAIN, imageId: image})
        })
    }
    return []
  }, [currentNewsItem])


  if (!currentNewsItem) {
    return <div className="news-article__empty"><Empty description="Новину не знайдено"/></div>
  }

  const publicationDate = currentNewsItem.created || currentNewsItem.$createdAt

  return <article className="news-article">
    <header className="news-article__header">
      <div className="news-article__eyebrow">Новини лікарні</div>
      <h1 className="news-article__title">{currentNewsItem.title}</h1>
      {publicationDate && <time className="news-article__date" dateTime={publicationDate}>
        <CalendarOutlined/>
        {dayjs(publicationDate).format("D MMMM YYYY")}
      </time>}
    </header>

    {currentNewsItem.mainImage && <div className="news-article__hero">
      <Image
        className="news-article__hero-image"
        preview={false}
        src={getImageLink({bucketId: BUCKETS.MAIN, imageId: currentNewsItem.mainImage})}
        alt={currentNewsItem.title}
      />
    </div>}

    <div className="news-article__body">
      <TextReader value={currentNewsItem.body}/>
    </div>

    {galleryImages.length > 0 && <section className="news-article__gallery">
      <h2 className="news-article__section-title"><PictureOutlined/> Фотогалерея</h2>
      <Gallery images={galleryImages}/>
    </section>}
  </article>
}

export default NewsItemPageBody
